// extracted by mini-css-extract-plugin
export var colorSquare = "_r2-0";
export var danger = "_r2-5";
export var lightPink = "_r2-8";
export var neutralBlue = "_r2-7";
export var neutralYellow = "_r2-6";
export var normal = "_r2-1";
export var primary = "_r2-2";
export var primaryLight = "_r2-3";
export var solidBlack = "_r2-g";
export var solidGreen = "_r2-b";
export var solidLightBlue = "_r2-d";
export var solidNavy = "_r2-c";
export var solidOrange = "_r2-f";
export var solidPink = "_r2-e";
export var solidRed = "_r2-9";
export var solidYellow = "_r2-a";
export var success = "_r2-4";